import { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import api from "@/lib/api";
import { toast } from "sonner";

const PROFILES = [
  { key: "child", emoji: "👦", label: "Enfant", hint: "Moins de 12 ans", desc: "Explications simples et rassurantes." },
  { key: "teen", emoji: "🧑", label: "Adolescent", hint: "12 à 17 ans", desc: "Comprendre ses droits et apprendre à réagir." },
  { key: "parent", emoji: "👨‍👩‍👧", label: "Parent", hint: "J'accompagne mon enfant", desc: "Accompagner et protéger son enfant." },
  { key: "adult", emoji: "👤", label: "Adulte", hint: "Pour moi-même", desc: "Informations complètes et démarches détaillées." },
];

export default function ProfilePicker() {
  const { user, refresh } = useAuth();
  const [busy, setBusy] = useState(false);
  if (!user || user.profile_chosen) return null;

  const pick = async (p) => {
    setBusy(true);
    try { await api.put("/me/profile", { profile: p }); await refresh(); toast.success("Profil enregistré. L'application s'adapte à vous."); }
    catch { toast.error("Impossible d'enregistrer le profil."); }
    finally { setBusy(false); }
  };

  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center p-4" data-testid="profile-picker">
      <div className="absolute inset-0 bg-black/85 backdrop-blur-md" />
      <div className="relative w-full max-w-lg card-surface p-6 fade-up">
        <p className="text-gold text-xs uppercase tracking-[0.2em] mb-2">Bienvenue</p>
        <h2 className="font-display text-2xl mb-1">Qui utilise BIZARRE AI ?</h2>
        <p className="text-white/55 text-sm mb-5">Nous adaptons le vocabulaire, les exemples et les conseils à votre profil. Vous pourrez le changer à tout moment.</p>
        <div className="grid grid-cols-2 gap-3">
          {PROFILES.map((p) => (
            <button key={p.key} data-testid={`pick-profile-${p.key}`} disabled={busy} onClick={() => pick(p.key)}
              className="card-surface p-4 text-left hover:border-gold/40 transition-colors disabled:opacity-50">
              <span className="text-3xl">{p.emoji}</span>
              <p className="font-display text-base mt-2">{p.label}</p>
              <p className="text-white/45 text-xs">{p.hint}</p>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}

export { PROFILES };
